export default class HttpError extends Error {
    constructor(status, statusText, body) {
        super(`HTTP ${status} ${statusText}: ${JSON.stringify(body)}`);
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
        this.name = 'RequestError';
        this.status = status;
        this.statusText = statusText;
        this.body = body;
    }
}
//# sourceMappingURL=HttpError.js.map